import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/bikes-for-sale/new")({
  loader: () => ({
    crumb: "alfred.pages.bikesForSale.crumbs.newBike",
  }),
})
